module.exports = __webpack_public_path__ + "static/media/plan.532192db.svg";